import React from 'react'
import { useTranslation } from 'react-i18next';
import translations from "../../Components/Translations/Translations.json";

const Weekdays = () => {
    const { t } = useTranslation();
    const storedLanguage = localStorage.getItem("lang") || "en";
    const selectedTranslation = translations[storedLanguage] || translations.en;
    const weekDays = [
        { key: 'monday', label: 'Monday', customBg: '#FF695F', text: 'text-white' },
        { key: 'tuesday', label: 'Tuesday' },
        { key: 'wednesday', label: 'Wednesday' },
        { key: 'thursday', label: 'Thursday' },
        { key: 'friday', label: 'Friday' },
        { key: 'saturday', label: 'Saturday' },
        { key: 'sunday', label: 'Sunday' },
    ];

    const commonClasses = "flex flex-col items-center justify-center font-medium rounded-lg";
    const commonStyle = { height: '60px', width: '10pvw' };
    const defaultBgClass = "bg-[#F6F6F6]";
    const defaultText = "text-black";

    return (
        <div className="grid justify-center grid-cols-7 gap-3 mt-10 mb-3 font-bold text-center">
            {weekDays.map(({ key, label, customBg, text }) => (
                <div
                    key={key}
                    className={`${commonClasses} ${text || defaultText} ${!customBg ? defaultBgClass : ''}`}
                    style={{
                        ...commonStyle,
                        ...(customBg ? { backgroundColor: customBg } : {})
                    }}
                >
                    <div>{label}</div>
                    <div>
                        <span className="font-medium">{t(selectedTranslation.labels[key])}</span>
                    </div>
                </div>
            ))}
        </div>
    );

};

export default Weekdays;